/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["table[_ngcontent-%COMP%]{table-layout:fixed;word-wrap:break-word;width:100%}@media screen and (max-width:1000px){.hide[_ngcontent-%COMP%]{display:none}}@media screen and (min-width:1000px){.show[_ngcontent-%COMP%]{display:none}}"];
export { styles as styles };
